module.exports = __webpack_public_path__ + "assets/logo.png";


//////////////////
// WEBPACK FOOTER
// ./clients/mfn-tij/images/logo.png
// module id = 440
// module chunks = 1